export const selectSubscriptionsByChannelIdAndEventIndex = (state) => {
  return state.Subscriptions.get('byChannel');
};

export const selectSubscriptionsById = (state) => {
  return state.Subscriptions.get('byId');
};

export const selectReadSubscriptionsById = (state) => {
  return state.Subscriptions.get('byId').filter((subscription) => {
    return subscription.get('isRead');
  });
};

export const selectUnreadSubscriptionsById = (state) => {
  return state.Subscriptions.get('byId').filter((subscription) => {
    return !subscription.get('isRead');
  });
};
